import AnalysisCategory from 'views/Analysis/AnalysisCategory';
import { AnalysisKinds, ComparisonKinds } from 'views/Analysis/analysisUtils';

// 分析（工事種・法人）
function AnalysisKoujiKbnPublic(props) {
  // 分析情報
  const analysisList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 分析種別
  const analysisKind = AnalysisKinds.find((x) => x.key == props.analysisKind);
  // 比較種別
  const comparisonKind = ComparisonKinds.find((x) => x.key == props.comparisonKind);

  // 集計項目
  const summaryItems = [
    // リピート
    { key: 'KOUJI_KBN2_2_3_1_1', label: 'リ・造園(新築)' },
    { key: 'KOUJI_KBN2_2_3_1_2', label: 'リ・造園(ﾘﾌｫｰﾑ)' },
    { key: 'KOUJI_KBN2_2_3_1_3', label: 'リ・造園(小工事)' },
    { key: 'KOUJI_KBN2_2_3_2_1', label: 'リ・建築(新築)' },
    { key: 'KOUJI_KBN2_2_3_2_2', label: 'リ・建築(ﾘﾌｫｰﾑ)' },
    { key: 'KOUJI_KBN2_2_3_2_3', label: 'リ・建築(小工事)' },
    { key: 'KOUJI_KBN2_2_3_3_4', label: 'リ・スポット管理' },
    { key: 'KOUJI_KBN2_2_3_3_5', label: 'リ・年間管理' },
    // 新規
    { key: 'KOUJI_KBN2_1_3_1_1', label: '新・造園(新築)' },
    { key: 'KOUJI_KBN2_1_3_1_2', label: '新・造園(ﾘﾌｫｰﾑ)' },
    { key: 'KOUJI_KBN2_1_3_1_3', label: '新・造園(小工事)' },
    { key: 'KOUJI_KBN2_1_3_2_1', label: '新・建築(新築)' },
    { key: 'KOUJI_KBN2_1_3_2_2', label: '新・建築(ﾘﾌｫｰﾑ)' },
    { key: 'KOUJI_KBN2_1_3_2_3', label: '新・建築(小工事)' },
    { key: 'KOUJI_KBN2_1_3_3_4', label: '新・スポット管理' },
    { key: 'KOUJI_KBN2_1_3_3_5', label: '新・年間管理' },
    // 新規・リピートの合計
    { key: 'KOUJI_KBN1_2_3', label: 'リピート', ignoreCalcTotal: true },
    { key: 'KOUJI_KBN1_1_3', label: '新規', ignoreCalcTotal: true },
  ];

  // ヘッダー
  const categoryHeader = [
    { category: 'リピート', start: 1, end: 16 },
    { category: '新規', start: 17, end: 32 },
  ];

  return (
    <AnalysisCategory
      analysisList={analysisList}
      selectedPeriod={selectedPeriod}
      summaryItems={summaryItems}
      analysisKind={analysisKind}
      categoryHeader={categoryHeader}
      comparisonKind={comparisonKind}
      categoryName="公共・工事種別"
      keyTotal="PUBLIC"
    />
  );
}
export default AnalysisKoujiKbnPublic;
